import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { OrderLiveAddressEntity } from '@/features/trackOrderTwo/domain/entities/orderEntities/OrderLiveAddressEntity'
import type { MonitorOrderAddressAdminDto } from '@/backend/market'

export class OrderLiveAddressModel extends OrderLiveAddressEntity {
  constructor(dataDto: MonitorOrderAddressAdminDto) {
    super()
    mapEntityProperties<OrderLiveAddressEntity>(this, dataDto)
  }
}
